import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ProtocolsAndStandardsModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Protocols and Standards"
    videos={[
      "https://www.youtube.com/embed/sjwXCIe7DTA"
    ]}
    takeaways={[
      { text: "Learn different protocols for different layers and be clear about the functionalities of the protocols." }
    ]}
    questions={[
      "Discuss the need for protocols and standards."
    ]}
    exampleVideos={[]}
  />
);
}

export default ProtocolsAndStandardsModule;
